import { Button, Dimensions, Image, StyleSheet, Text, View } from 'react-native';
import React, { FC, useCallback, useEffect, useRef, useState } from 'react';
import { FeatureSectionProps } from './FeatureSection.type';
import styles from './FeatureSecion.styled';
import { TouchableOpacity } from 'react-native';
import Swiper from 'react-native-web-swiper';
import { ProductItem } from '../../../components';
import { ProductItem as ProductItemProps } from '../../../components/ProductItem/ProductItem.type';
import { useIsDesktop } from '../../../../../hooks/useIsDeskTop';
import { COLORS, FONTS } from '../../../../../constants';
import { Product } from '../../../../../types/woocommerce.types';
import ProductWooItem from '../../../components/ProductWooItem';
import { wooCommerceApi } from '../../../../../services/api/wooCommerceApi';
import { NavigationService } from '../../../../../services/navigation';
import { useDispatch } from 'react-redux';

const FeatureSection: FC<FeatureSectionProps> = ({
  category,
}) => {
  const [productHeight, setProductHeight] = useState(0);
  const isDesktop = useIsDesktop();
  const swiperRef = useRef<Swiper>(null);
  const [products, setProducts] = useState<Product[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const dispatch = useDispatch();

  const getProducts = useCallback(
    async () => {
      try {
        setIsLoading(true);
        const res = await wooCommerceApi.get('products', {
          per_page: 12,
          category: category.id,
        });
        setProducts(res.data);
      } catch (error: any) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    }, [category]
  )

  useEffect(() => {
    getProducts();
  }, [getProducts]);

  const render = useCallback(
    (product: Product, productHeight: number) => {
      console.log('ent', productHeight);

      return (
        <View
          style={{ height: productHeight }}
          onLayout={(e) => {
            console.log('okok', e.nativeEvent.layout.width);

            // setProductHeight(Math.round(e.nativeEvent.layout.width));
          }}
        >
          <ProductWooItem product={product} type="grid" />
        </View>
      );
    },
    []
  );
  const renderSwiper = useCallback(() => {
    // const resul: React.JSX.Element[] = [];
    // for (let i = 0; i < products.length; i += 2) {}
    var allGroup: React.JSX.Element[] = [];
    var group: React.JSX.Element[] = [];
    products.map((product, index) => {
      group.push(
        <View
          key={index}
          style={{
            flex: 0.3333333333,
            minWidth: 250,
        }}
        >
          <ProductWooItem
            product={product}
            type="grid"
            key={product.id}
            categoryName={category.name}
          />
        </View>
      )
      if (((index + 1) % 3 === 0 && index !== 0) || (index === products.length - 1)) {
        allGroup.push(
          <View
            style={{
              flexDirection: 'row',
              alignItems: 'flex-start',
              flexWrap: 'wrap',
              gap: 20,
            }}
          >{group}</View>
        );
        group = [];
      }
    });

    if (isDesktop()) {
      return (
        <Swiper
          controlsProps={{
            prevPos: false,
            nextPos: false,
            DotComponent: () => <></>,
          }}
          timeout={5}
          loop
          from={1}
          ref={swiperRef}
        >
          {allGroup}
        </Swiper>
      );
    }

    return (
      <Swiper
        controlsProps={{
          prevPos: false,
          nextPos: false,
          // DotComponent: () => <Text>ok</Text>,
        }}
        timeout={5}
        loop
      >
        <>
          {products.map((product, index) => {
            return <View key={index}>{render(product, productHeight)}</View>;
          })}
        </>
      </Swiper>
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [products, render, productHeight, swiperRef]);

  if (isDesktop()) {
    return (
      <View style={{
        marginBottom: 40
      }}>
        <Text style={[styles.nameSectionText, {marginBottom: 30}]}>{`Feature ${category.name}`}</Text>
        {isLoading === true
          ? <Text
              style={{
                textTransform: 'uppercase',
                color: COLORS.GREEN,
                fontSize: 20,
                fontFamily: FONTS.IowanOldStyleBTRoman,
                textAlign: 'center',
              }}
            >Loading....</Text>
          : products.length > 0
            ? <View
                style={{
                  height: 450,
                  width: '100%',
                }}
              >
                {renderSwiper()}
              </View>
            : <Text style={{
                textTransform: 'uppercase',
                color: COLORS.GREEN,
                fontSize: 20,
                fontFamily: FONTS.IowanOldStyleBTRoman,
                textAlign: 'center',
                marginVertical: 20,
              }}>
                No data
              </Text>
        }
        <View style={{
          flexDirection: 'row',
          justifyContent: 'center',
          marginTop: 20,
          marginBottom: 20,
        }}>
          {products.length > 0 && (
            <View style={{ flexDirection: 'row' }}>
              <TouchableOpacity
                style={{
                  borderColor: COLORS.GREEN,
                  borderWidth: 1,
                  width: 30,
                  height: 30,
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginRight: 10,
                }}
                onPress={() => {
                  swiperRef.current?.goToPrev();
                }}
              >
                <Image
                  source={require('../../../../../assets/left-arrow.png')}
                  style={{
                    width: 11,
                    height: 11,
                    tintColor: COLORS.GREEN,
                  }}
                />
              </TouchableOpacity>
              <TouchableOpacity
              style={{
                borderColor: COLORS.GREEN,
                borderWidth: 1,
                width: 30,
                height: 30,
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
              }}
              onPress={() => {
                swiperRef.current?.goToNext();
              }}
              >
                <Image
                  source={require('../../../../../assets/right-arrow.png')}
                  style={{
                    width: 11,
                    height: 11,
                    tintColor: COLORS.GREEN,
                  }}
                />
              </TouchableOpacity>
            </View>
          )}
          <TouchableOpacity
            style={{
              position: 'absolute',
              right: 0,
            }}
            onPress={() => {
              NavigationService.push('EShopCategoryPage', {
                name: category.slug,
              });
            }}
          >
            <Text style={{
              textTransform: 'uppercase',
              fontFamily: FONTS.AvenirMedium,
              color: COLORS.GREEN,
              textDecorationLine: 'underline',
              fontSize: 15,
            }}>Show all {category.name}</Text>
          </TouchableOpacity>
        </View>
      </View>
    )
  }

  return (
    <View style={styles.wrapper}>
      <Text style={styles.nameSectionText}>{`Feature ${name}`}</Text>
      <View style={styles.contentContainer}>{renderSwiper()}</View>
      <TouchableOpacity activeOpacity={1}>
        <Text style={styles.showAllText}>{`Show all ${name}`}</Text>
      </TouchableOpacity>
    </View>
  );
};

export default FeatureSection;
